"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.cookieCutterSlice = cookieCutterSlice;
const cookieUtils_1 = require("../../components/cookies/cookieUtils");
const cookie_1 = require("../../router/routes/cookie");
const storedConsent = (0, cookieUtils_1.getStoredConsent)();
const cookieCutterInitialState = {
    cookies: {
        ...storedConsent,
        open: !(0, cookieUtils_1.areCookiesSaved)() && globalThis.location.pathname !== cookie_1.cookieNoticePath,
        showManageCookies: false,
    },
};
function cookieCutterSlice(set) {
    return {
        ...cookieCutterInitialState,
        initializeCookiesFromStorage() {
            set(state => {
                const storedConsent = (0, cookieUtils_1.getStoredConsent)();
                return {
                    ...state,
                    cookies: {
                        ...state.cookies,
                        preferences: storedConsent.preferences,
                        statistics: storedConsent.statistics,
                        marketing: storedConsent.marketing,
                    },
                };
            }, false, '[initializeCookiesFromStorage]');
        },
        setIsCookieCutterOpen(open) {
            set((state) => ({
                ...state,
                cookies: {
                    ...state.cookies,
                    open,
                },
            }), false, '[setIsCookieCutterOpen]');
        },
        setShowManageCookies(show) {
            set((state) => ({
                ...state,
                cookies: {
                    ...state.cookies,
                    showManageCookies: show,
                },
            }), false, '[setShowManageCookies]');
        },
        togglePreferences() {
            set((state) => ({
                ...state,
                cookies: {
                    ...state.cookies,
                    preferences: !state.cookies.preferences,
                },
            }), false, '[togglePreferences]');
        },
        toggleStatistics() {
            set((state) => ({
                ...state,
                cookies: {
                    ...state.cookies,
                    statistics: !state.cookies.statistics,
                },
            }), false, '[toggleStatistics]');
        },
        toggleMarketing() {
            set((state) => ({
                ...state,
                cookies: {
                    ...state.cookies,
                    marketing: !state.cookies.marketing,
                },
            }), false, '[toggleMarketing]');
        },
        acceptAll() {
            set((state) => {
                (0, cookieUtils_1.acceptAllCookies)();
                return {
                    ...state,
                    cookies: {
                        ...state.cookies,
                        preferences: true,
                        statistics: true,
                        marketing: true,
                    },
                };
            }, false, '[acceptAll]');
        },
        declineAll() {
            set((state) => {
                (0, cookieUtils_1.declineAllCookies)();
                return {
                    ...state,
                    cookies: {
                        ...state.cookies,
                        preferences: false,
                        statistics: false,
                        marketing: false,
                    },
                };
            }, false, '[declineAll]');
        },
        saveConsent() {
            set((state) => {
                const consent = {
                    necessary: true,
                    preferences: state.cookies.preferences,
                    statistics: state.cookies.statistics,
                    marketing: state.cookies.marketing,
                };
                (0, cookieUtils_1.updateCookiesBasedOnConsent)(consent);
                return {
                    ...state,
                    cookies: {
                        ...state.cookies,
                        showManageCookies: false,
                        open: false,
                    },
                };
            }, false, '[saveConsent]');
        },
    };
}
